<a mat-list-item (click)="onClick()" class="no-pad-item-content">
  <i mat-icon [class]="'fa event-icon color-white ' + getEventDateClass()"></i>
  <div class="event-content">
    <p class="event-time">{{getEventDate()}} | <strong>{{getEventTime()}}</strong></p>
    <p class="event-details">{{event.details}}</p>
  </div>
</a>
